import Vue from 'vue'
import Router from 'vue-router'
import Zcl from '@/components/Zcl/Zcl'
import Home from '@/components/Home/Home'
import AllCourse from '@/components/AllCourse/AllCourse'
import BookCourse from '@/components/BookCourse/BookCourse'
import BookCourseDetail from '@/components/BookCourseDetail/BookCourseDetail'
import ICourse from '@/components/ICourse/ICourse'
import MyFind from '@/components/MyFind/MyFind'
import LiveCourse from '@/components/LiveCourse/LiveCourse'
import MyClass from '@/im/my-class'
import CourseDetail from '@/components/CourseDetail/CourseDetail'
import Community from '@/components/Community/Community'
import Player from '@/components/Player/Player'
import liveBackPlayer from '@/components/liveBackPlayer/liveBackPlayer'
import Accound from '@/components/Accound/Accound'
import Plan from '@/components/Plan/Plan'
import News from '@/components/News/News'
import PlanDetail from '@/components/PlanDetail/PlanDetail'
import AccStudyPlan from '@/components/AccStudyPlan/AccStudyPlan.vue'
import AccMyStudy from '@/components/AccMyStudy/AccMyStudy.vue'
import AccMyTool from '@/components/AccMyTool/AccMyTool.vue'
import AccSetting from '@/components/AccSetting/AccSetting.vue'
import AccExam from '@/components/AccExam/AccExam.vue'
import AccAccound from '@/components/AccAccound/AccAccound.vue'
import AccLive from '@/components/AccLive/AccLive.vue'
import Feedback from '@/components/Feedback/Feedback.vue'
import RankList from '@/components/RankList/RankList.vue'
import ForGetPassword from '@/components/ForGetPassword/ForGetPassword.vue'
import PdfShow from '@/components/PdfShow/PdfShow.vue'
import WrongBook from '@/components/WrongBook/WrongBook.vue'
import SpecialEx from '@/components/SpecialEx/SpecialEx.vue'
import Exercise from '@/components/Exercise/Exercise.vue'
import Analysis from '@/components/Analysis/Analysis.vue'
import Exam from '@/components/Exam/Exam.vue'
import Results from '@/components/Results/Results.vue'
import ExamDetail from '@/components/ExamDetail/ExamDetail.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Zcl,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: 'AllCourse',
          name: 'AllCourse',
          component: AllCourse,
          meta:{title:'全部课程'}
        },
        {
          path: 'ICourse',
          name: 'ICourse',
          component: ICourse,
          meta:{title:'重要课程'}
        },
        {
          path: 'BookCourse',
          name: 'BookCourse',
          component: BookCourse,
          meta:{title:'图书课程'}
        },
        {
          path: 'MyFind',
          name: 'MyFind',
          component: MyFind,
          meta:{title:'我的发现'}
        },
        {
          path: 'LiveCourse',
          name: 'LiveCourse',
          component: LiveCourse,
          meta:{title:'直播课程'}
        },
        {
          path: 'MyClass',
          name: 'MyClass',
          component: MyClass,
          meta:{title:'我的班级'}
        },
        {
          path: 'CourseDetail',
          name: 'CourseDetail',
          component: CourseDetail
        },
        {
          path: 'BookCourseDetail',
          name: 'BookCourseDetail',
          component: BookCourseDetail
        },
        {
          path: '/Community',
          name: 'Community',
          component: Community
        },
        {
          path: 'PlanDetail',
          name: 'PlanDetail',
          component: PlanDetail
        },
        {
          path: 'RankList',
          name: 'RankList',
          component: RankList
        },
        {
          path: 'Player',
          name: 'Player',
          component: Player
        },
        {
          path: 'liveBackPlayer',
          name: 'liveBackPlayer',
          component: liveBackPlayer
        },
        {
          path: 'WrongBook',
          name: 'WrongBook',
          component: WrongBook
        },
        {
          path: 'SpecialEx',
          name: 'SpecialEx',
          component: SpecialEx
        },
        {
          path: 'Exercise',
          name: 'Exercise',
          component: Exercise
        },
        {
          path: 'Analysis',
          name: 'Analysis',
          component: Analysis
        },
        {
          path: 'Exam',
          name: 'Exam',
          component: Exam
        },
        {
          path: 'Results',
          name: 'Results',
          component: Results
        },
        {
          path: 'ExamDetail',
          name: 'ExamDetail',
          component: ExamDetail
        },
        {
          path: 'Accound',
          component: Accound,
          children: [
            {
              path: '/',
              name: 'AccStudyPlan',
              component: AccStudyPlan
            },
            {
              path: '/AccMyStudy',
              name: 'AccMyStudy',
              component: AccMyStudy
            },
            {
              path: '/AccMyTool',
              name: 'AccMyTool',
              component: AccMyTool
            },
            {
              path: '/AccSetting',
              name: 'AccSetting',
              component: AccSetting
            },
            {
              path: '/AccExam',
              name: 'AccExam',
              component: AccExam
            },
            {
              path: '/AccAccound',
              name: 'AccAccound',
              component: AccAccound
            },
            {
              path: '/AccLive',
              name: 'AccLive',
              component: AccLive
            },

          ],
          meta:{title:'个人中心'}
        },
        {
          path: 'Plan',
          name: 'Plan',
          component: Plan
        },
        {
          path: 'News/:id',
          name: 'News',
          component: News
        },
        {
          path: 'Feedback',
          name: 'Feedback',
          component: Feedback
        },
        {
          path: 'ForGetPassword',
          name: 'ForGetPassword',
          component: ForGetPassword
        },
      ]
    },
    {
      path: '/PdfShow',
      name: 'PdfShow',
      component: PdfShow
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js